<section class="vc-admin-detail-shell">
  <app-admin-page-header
    [titleKey]="titleKey"
    [descriptionKey]="descriptionKey"
    [showBack]="showBack"
    [backLink]="backLink"
    [contextLabelKey]="contextLabelKey"
    [contextValue]="contextValue"
  >
    <ng-content select="[header-actions]"></ng-content>
  </app-admin-page-header>

  @if (tabs.length > 0) {
    <nav class="vc-admin-detail-shell__tabs">
      @for (tab of tabs; track tab.route) {
        <a
          class="vc-admin-detail-shell__tab"
          [routerLink]="tab.route"
          routerLinkActive="vc-admin-detail-shell__tab--active"
          [routerLinkActiveOptions]="{ exact: tab.exact !== false }"
        >
          <i [class]="tab.icon"></i>
          <span>{{ tab.labelKey | translate }}</span>
        </a>
      }
    </nav>
  }

  <div class="vc-admin-detail-shell__content vc-admin-content-scope">
    <router-outlet></router-outlet>
  </div>
</section>
